import { useState, type ReactNode } from "react";
import { Icon } from "@common/index";

interface InfoAccordionProps {
    title: string;
    defaultOpen?: boolean;
    children: ReactNode;
    testId?: string;
}

export const InfoAccordion = ({
    title,
    defaultOpen = false,
    children,
    testId,
}: InfoAccordionProps) => {
    const [open, setOpen] = useState(defaultOpen);

    return (
        <section
            data-testid={testId}
            className="rounded-lg border border-base-300"
        >
            <button
                type="button"
                aria-expanded={open}
                onClick={() => setOpen((prev) => !prev)}
                className="flex w-full items-center justify-between px-4 py-3 text-left font-bold text-neutral"
            >
                <span>{title}</span>
                <Icon
                    name={open ? "remove" : "add"}
                    className="text-xl text-neutral"
                />
            </button>
            {open && (
                <div className="border-t border-base-300 px-4 py-3 text-sm text-neutral">
                    {children}
                </div>
            )}
        </section>
    );
};
